import React from "react";

const API2SQL = (
  <span>
    API<u>2</u>SQL
  </span>
);

export default API2SQL;
